/**
 * F11 / F12 — Helpers para gerar e baixar CSV client-side. Formato compatível
 * com Excel (locale FR/BR): separador `;`, BOM utf-8, line break `\r\n`,
 * escape RFC 4180 (aspas duplas + valores com `;`/`"`/quebra de linha).
 *
 * Uso:
 *   downloadCsv("relatorio_2026-05.csv",
 *     ["Data", "Cliente", "Valor"],
 *     rows.map(r => [r.data, r.cliente, r.valor.toFixed(2)])
 *   );
 */

/** Escape de 1 valor segundo RFC 4180 (aspas duplas quando necessário). */
export function csvEscape(v: unknown): string {
  if (v === null || v === undefined) return "";
  const s = String(v);
  if (s.includes(";") || s.includes('"') || s.includes("\n") || s.includes("\r")) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}

/** Monta string CSV completa (sem BOM). Útil para tests/preview. */
export function buildCsv(
  headers: ReadonlyArray<string>,
  rows: ReadonlyArray<ReadonlyArray<unknown>>,
): string {
  return [headers.map(csvEscape).join(";"), ...rows.map((r) => r.map(csvEscape).join(";"))].join(
    "\r\n",
  );
}

/** Dispara download no browser. BOM utf-8 antes do conteúdo para Excel. */
export function downloadCsv(
  filename: string,
  headers: ReadonlyArray<string>,
  rows: ReadonlyArray<ReadonlyArray<unknown>>,
): void {
  const bom = "﻿";
  const blob = new Blob([bom + buildCsv(headers, rows)], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
